import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LEGAL_URLS } from '../../lib/legal';
import styles from './CookieBanner.module.css';

const STORAGE_KEY = 'etap_cookie_notice';

const wasDismissed = () => {
  try {
    return Boolean(window.localStorage.getItem(STORAGE_KEY));
  } catch {
    return false;
  }
};

/**
 * Уведомление о cookie и Яндекс Метрике — информационное: Метрика работает
 * и без нажатия, «Понятно» только прячет плашку навсегда.
 */
export function CookieBanner({ aboveTabBar = false }: { aboveTabBar?: boolean }) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(() => !wasDismissed());

  if (!visible) return null;

  const dismiss = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  return (
    <div className={`${styles.banner} ${aboveTabBar ? styles.aboveTabBar : ''}`} role="region" aria-label="Cookie">
      <p className={styles.text}>
        {t('legal.cookieText')}{' '}
        <a href={LEGAL_URLS.cookies} target="_blank" rel="noreferrer" className={styles.link}>
          {t('legal.cookieLink')}
        </a>.
      </p>
      <button type="button" className={styles.button} onClick={dismiss}>
        {t('legal.cookieOk')}
      </button>
    </div>
  );
}
